module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_7005.6760c013.png";